import React, {Component} from "react";

// Monograma, no el logo de la marca: identifica al canal en Conexiones, en las conexiones del cliente y en
// el portal con el mismo tamaño que el resto de los logos.
export class EscalafyLogo extends Component {
    getHeight() {
        if(this.props.height)
            return this.props.height;
        return 30;
    }

    getWidth() {
        if(this.props.width)
            return this.props.width;
        return 30;
    }

    getHSpace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVSpace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    render() {
        const style = {
            ...this.props.styles,
            marginRight: this.getHSpace(),
            marginTop: this.getVSpace(),
            marginBottom: this.getVSpace(),
        };

        return (
            <svg
                className="escalafy-logo"
                viewBox="0 0 800 800"
                height={this.getHeight()}
                width={this.getWidth()}
                style={style}
                role="img"
                aria-label="Escalafy"
            >
                <rect width="800" height="800" rx="160" fill="#1F2A44"/>
                <path d="M250 200H560V290H355V355H530V445H355V510H560V600H250Z" fill="#FFFFFF"/>
            </svg>
        );
    }
}
